export default __webpack_public_path__ + "static/media/VSC.0e5daeab.svg";